import { t } from '@/plugins/i18n'
import { isD2C, getCustomerShopPlatform, isMultiStore } from '@/store'

export const d2cEditableTabs = [
  {
    title: t('问题处理2'),
    name: 'ProblemHandling'
  },
  {
    title: t('待确认运输方式'),
    name: 'ConfirmType'
  },
  {
    title: t('售后'),
    name: 'AfterSales'
  },
  {
    title: t('商品取消履历'),
    name: 'ApplyCancel'
  }
]

export const b2bEditableTabs = [
  {
    title: t('问题处理2'),
    name: 'ProblemHandling'
  },
  {
    title: t('商品取消履历'),
    name: 'ApplyCancel'
  }
]

export const afterSalesProgressDict: any = {
  0: t('待处理'),
  1: t('业务处理中'),
  2: t('财务处理中'),
  3: t('已退款'),
  4: t('已拒绝'),
  5: t('重新发起（处理中）'),
  6: t('已撤销')
}

export const afterSalesReasonDict: any = {
  1: t('次品'),
  2: t('相异品'),
  3: t('数量不足'),
  4: t('其他')
}

export const cancelProgressOption: any = {
  0: t('处理中'),
  1: t('取消成功'),
  2: t('保留库存')
}
export const cancelProgressDict: any = {
  0: t('处理中'),
  1: t('取消成功'),
  2: t('取消成功'), // 保留库存
  3: t('次品为公司所有'),
  4: t('次品转用户库存')
}

//  ProblemHandling问题处理
export const b2bProblemHandlingColumns1:any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 200,
    slotName: 'platformOrderNo'
  },
  {
    label: t('订单标题'),
    prop: 'customerOrderNo',
    width: 200,
    slotName: 'customerOrderNo'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productProp',
    align: 'center',
    slotName: 'productProp',
    width: 130
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 180,
    slotName: 'productSku'
  },
  {
    label: t('店铺商品sku'),
    prop: 'shopProductSku',
    align: 'center',
    width: 180
  },
  {
    label: t('下单数量'),
    align: 'center',
    slotName: 'orderNum'
  },
  {
    label: t('最新问题时间'),
    prop: 'createTime',
    align: 'center',
    width: 230,
    slotName: 'createTime'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'orderStatus'
  }
]
//  ProblemHandling问题处理
export const d2cProblemHandlingColumns1:any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 200,
    slotName: 'platformOrderNo'
  },
  {
    label: t('客户订单编号'),
    prop: 'customerOrderNo',
    width: 200,
    slotName: 'customerOrderNo'
  },
  {
    label: t('订单') + `(${getCustomerShopPlatform()})`,
    prop: 'orderName',
    width: 200,
    slotName: 'orderName'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productProp',
    align: 'center',
    slotName: 'productProp',
    width: 130
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 180,
    slotName: 'productSku'
  },
  {
    label: t('店铺商品sku'),
    prop: 'shopProductSku',
    align: 'center',
    width: 180
  },
  {
    label: t('下单数量'),
    align: 'center',
    slotName: 'orderNum'
  },
  {
    label: t('最新问题时间'),
    prop: 'createTime',
    align: 'center',
    width: 230,
    slotName: 'createTime'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'orderStatus'
  }
]
//  ProblemHandling问题处理
export const b2bProblemHandlingColumns0:any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 200,
    slotName: 'platformOrderNo'
  },
  {
    label: t('订单标题'),
    prop: 'customerOrderNo',
    width: 200,
    slotName: 'customerOrderNo'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productProp',
    align: 'center',
    slotName: 'productProp',
    width: 130
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 180,
    slotName: 'productSku'
  },
  {
    label: t('店铺商品sku'),
    prop: 'shopProductSku',
    align: 'center',
    width: 180
  },
  {
    label: t('下单数量'),
    align: 'center',
    slotName: 'orderNum'
  },
  {
    label: t('最新问题时间'),
    prop: 'createTime',
    align: 'center',
    width: 230,
    slotName: 'createTime'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'orderStatus'
  }
  // {
  //   label: t('处理方式'),
  //   prop: 'customerOperateType',
  //   align: 'center',
  //   slotName: 'customerOperateType'
  // }
]
//  ProblemHandling问题处理
export const d2cProblemHandlingColumns0:any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 200,
    slotName: 'platformOrderNo'
  },
  {
    label: t('客户订单编号'),
    prop: 'customerOrderNo',
    width: 200,
    slotName: 'customerOrderNo'
  },
  {
    label: t('订单') + `(${getCustomerShopPlatform()})`,
    prop: 'orderName',
    width: 200,
    slotName: 'orderName'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productProp',
    align: 'center',
    slotName: 'productProp',
    width: 130
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 180,
    slotName: 'productSku'
  },
  {
    label: t('店铺商品sku'),
    prop: 'shopProductSku',
    align: 'center',
    width: 180
  },
  {
    label: t('下单数量'),
    align: 'center',
    slotName: 'orderNum'
  },
  {
    label: t('最新问题时间'),
    prop: 'createTime',
    align: 'center',
    width: 230,
    slotName: 'createTime'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'orderStatus'
  }
  // {
  //   label: t('处理方式'),
  //   prop: 'customerOperateType',
  //   align: 'center',
  //   slotName: 'customerOperateType'
  // }
]
export const problemHandlingTableConfig = {
  showHandler: false,
  canRowClick: true,
  showExpand: true,
  rowKey: 'orderNo',
  height: 600
}

export const customerOperateTypeDict: any = {
  1: t('更换颜色'),
  2: t('更换尺码'),
  3: t('更换款式'),
  4: t('换个链接'),
  5: t('取消商品'),
  6: t('选择同款'),
  7: t('选择类似款'),
  8: t('下单原链接'),
  9: t('推荐链接'),
  10: t('下单原链接（多出数量保留库存）'),
  11: t('良品入库'),
  12: t('不良品'),
  13: t('确认重拍'),
  14: t('按原价采购')
}

//  ApplyCancel
export const applyCancelColumns1:any = [
  {
    label: t('取消类型'),
    prop: 'cancelType',
    align: 'center',
    width: 140,
    slotName: 'cancelType'
  },
  {
    label: t('取消原因'),
    prop: 'productQuestionReason',
    align: 'center',
    slotName: 'productQuestionReason',
    width: 200
  },
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 200,
    slotName: 'platformOrderNo'
  },
  {
    label: isD2C() ? t('客户订单编号') : t('订单标题'),
    prop: 'customerOrderNo'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName',
    width: 150
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 180,
    slotName: 'productSku'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('取消数量'),
    prop: 'cancelQuantity',
    align: 'center',
    width: 140
  },
  {
    label: t('申请时间'),
    prop: 'cancelApplyTime',
    align: 'center',
    width: 230,
    slotName: 'cancelApplyTime'
  }
  // {
  //   label: t('退款金额'),
  //   prop: 'cancelRefundAmount',
  //   align: 'center'
  // },
  // {
  //   label: t('取消进度'),
  //   prop: 'cancelProgress',
  //   align: 'center',
  //   slotName: 'cancelProgress'
  // }
]
export const applyCancelColumns2:any = [
  {
    label: t('取消类型'),
    prop: 'cancelType',
    align: 'center',
    width: 140,
    slotName: 'cancelType'
  },
  {
    label: t('取消原因'),
    prop: 'productQuestionReason',
    align: 'center',
    slotName: 'productQuestionReason',
    width: 200
  },
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 200,
    slotName: 'platformOrderNo'
  },
  {
    label: isD2C() ? t('客户订单编号') : t('订单标题'),
    prop: 'customerOrderNo'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName',
    width: 150
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 180,
    slotName: 'productSku'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('取消数量'),
    prop: 'cancelQuantity',
    align: 'center',
    width: 140
  },
  {
    label: t('结算时应退款金额'),
    prop: 'cancelRefundAmount',
    align: 'center',
    width: 230,
    slotHeadName: 'cancelRefundAmountHead',
    slotName: 'cancelRefundAmount'
  },
  {
    label: t('申请时间'),
    prop: 'cancelApplyTime',
    align: 'center',
    width: 230,
    slotName: 'cancelApplyTime'
  }
]
export const applyCancelTableConfig = {
  rowKey: 'abnormalOrderId',
  canRowClick: true,
  showHandler: true,
  setHeight: true
}

//  AfterSales
export const d2cAfterSalesColumns:any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 200,
    slotName: 'platformOrderNo'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName',
    width: 130
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 180,
    slotName: 'productSku'
  },
  {
    label: t('申请售后件数'),
    prop: 'applyAfterSalesQuantity',
    align: 'center',
    width: 120
  },
  {
    label: t('售后原因'),
    prop: 'afterSalesReason',
    align: 'center',
    slotName: 'afterSalesReason',
    width: 120
  },
  {
    label: t('申请售后时间'),
    prop: 'applyAfterSalesTime',
    align: 'center',
    width: 230,
    slotName: 'applyAfterSalesTime'
  },
  {
    label: t('售后进度'),
    prop: 'afterSalesProgress',
    align: 'center',
    slotName: 'afterSalesProgress'
  },
  {
    label: t('拒绝原因'),
    prop: 'refuseReason',
    align: 'center'
  },
  {
    label: t('退款总金额'),
    prop: 'afterSalesRefundTotalAmount',
    align: 'center',
    slotName: 'afterSalesRefundTotalAmount'
  },
  {
    label: t('退款说明'),
    prop: 'detailedExplain',
    align: 'center',
    width: 120
  }
]

//  AfterSales
export const b2bAfterSalesColumns:any = [
  {
    label: t('国际发货单号'),
    prop: 'deliveryTaskCode',
    width: 200
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName',
    width: 130
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 180,
    slotName: 'productSku'
  },
  {
    label: t('申请售后件数'),
    prop: 'applyAfterSalesQuantity',
    align: 'center',
    width: 120
  },
  {
    label: t('售后原因'),
    prop: 'afterSalesReason',
    align: 'center',
    slotName: 'afterSalesReason',
    width: 120
  },
  {
    label: t('申请售后时间'),
    prop: 'applyAfterSalesTime',
    align: 'center',
    width: 230,
    slotName: 'applyAfterSalesTime'
  },
  {
    label: t('售后进度'),
    prop: 'afterSalesProgress',
    align: 'center',
    slotName: 'afterSalesProgress'
  },
  {
    label: t('拒绝原因'),
    prop: 'refuseReason',
    align: 'center'
  },
  {
    label: t('退款总金额'),
    prop: 'afterSalesRefundTotalAmount',
    align: 'center',
    slotName: 'afterSalesRefundTotalAmount'
  },
  {
    label: t('退款说明'),
    prop: 'detailedExplain',
    align: 'center',
    width: 120,
    slotName: 'detailedExplain'
  }
]

export const afterSalesTableConfig = {
  rowKey: 'abnormalOrderId',
  canRowClick: true,
  showHandler: true,
  setHeight: true
}

export const tableApiConfig = {
  listPath: 'data'
}

/** ------------------------------------------ */

export const preferDeliverFlagEnum = {
  0: t('不可优先发货'),
  1: t('可优先发货(订单下部分商品已全部上架)')
}

//  待确认运输方式
export const confirmTypeOrderColumns:any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    align: 'center',
    width: 180,
    slotName: 'platformOrderNo'
  },
  {
    label: t('客户订单编号'),
    prop: 'customerOrderNo',
    width: 200,
    slotName: 'customerOrderNo'
  },
  {
    label: t('原运输方式'),
    align: 'center',
    prop: 'originalDistribution',
    width: 200
  },
  {
    label: t('变更理由'),
    prop: 'changeReason',
    slotName: 'changeReason',
    align: 'center',
    width: 150
  },
  {
    label: t('建议运输方式'),
    prop: 'recommendDistribution',
    align: 'center',
    slotName: 'recommendDistribution',
    width: 180
  },
  {
    label: t('发货地'),
    prop: 'goodsCountry',
    align: 'center',
    slotName: 'goodsCountry',
    width: 180,
    isMultiStore: true
  },
  {
    label: t('下单数量'),
    prop: 'totalOrderQuantity',
    align: 'center'
  },
  {
    label: t('下单时间'),
    prop: 'orderCreateTime',
    slotName: 'orderCreateTime',
    align: 'center',
    width: 120
  }
]
export const confirmTypeSkuColumns:any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    align: 'center',
    width: 140,
    slotName: 'platformOrderNo'
  },
  {
    label: t('客户订单编号'),
    prop: 'customerOrderNo',
    width: 200,
    slotName: 'customerOrderNo'
  },
  {
    label: t('原运输方式'),
    align: 'center',
    prop: 'originalDistribution',
    width: 200
  },
  {
    label: t('发货地'),
    prop: 'goodsCountry',
    align: 'center',
    slotName: 'goodsCountry',
    width: 180,
    isMultiStore: true
  },
  {
    label: t('下单数量'),
    prop: 'totalOrderQuantity',
    align: 'center'
  },
  {
    label: t('下单时间'),
    prop: 'orderCreateTime',
    align: 'center',
    slotName: 'orderCreateTime',
    width: 120
  }
]
export const confirmSkuSecondColumns:any = [
  {
    label: t('商品信息'),
    prop: 'productSkuImg',
    align: 'center',
    slotName: 'productSkuImg',
    width: 200
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center'
    // width: 120
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center'
    // width: 120
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('变更理由'),
    prop: 'changeReason',
    align: 'center',
    slotName: 'changeReason',
    width: 260
  },
  {
    label: t('建议运输方式'),
    prop: 'recommendDistribution',
    align: 'center',
    slotName: 'recommendDistribution',
    width: 260
  }
]
/** 待确认-sku-dialog */
export const skuDialogColumns:any = [
  {
    label: t('商品信息'),
    prop: 'productSkuImg',
    align: 'center',
    slotName: 'productSkuImg',
    width: 170
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center'
    // width: 120
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    width: 115
  },

  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
    // width: 120
  },
  {
    label: t('变更理由'),
    prop: 'changeReason',
    align: 'center',
    slotName: 'changeReason'
    // width: 120
  },
  {
    label: t('建议运输方式'),
    prop: 'recommendDistribution',
    slotHeadName: 'recommendDistributionHead',
    align: 'center',
    slotName: 'recommendDistribution'
    // width: 120
  }
  // {
  //   label: t('处理方式'),
  //   prop: 'handleWay',
  //   align: 'center',
  //   slotName: 'handleWay',
  //   width: 220
  // }
]
export const tableConfigOrder = {
  showHandler: true,
  setHeight: true,
  handlerConfig: { label: t('操作'), width: 280 }
}
export const tableConfigSku = {
  // showSelection: true,
  showHandler: true,
  showExpand: true,
  setHeight: true,
  rowKey: 'platformOrderNo',
  handlerConfig: { label: t('操作'), width: 280 }
}

export const tableConfigSkuDialog = {
  showSelection: true,
  // showHandler: true,
  setHeight: true
  // handlerConfig: { label: t('处理方式'), align: 'center' }
}
export const changeReasonCodes: any = {
  AR_0000: '-',
  AR_0001: t('涉及药事法'),
  AR_0002: t('涉及食品法'),
  AR_0003: t('带电池'),
  AR_0004: t('木制品'),
  AR_0005: t('侵权产品'),
  AR_0006: t('易燃易爆物品'),
  AR_0007: t('武器配件，管制刀具等'),
  AR_0008: t('动植物产品'),
  AR_0009: t('不满足发货重量要求'),
  AR_0010: t('价格过高'),
  AR_0011: t('粉末'),
  AR_0012: t('液体')
}
